import * as React from 'react';

import { VisuallyHidden } from '@reach/visually-hidden';

import { theme } from '../../../../styles/2020/theme';

import { Center } from '../../layout/Center';

export type DiagramProps = {
  image: React.ReactNode;
  screenReaderText?: string[];
};

export function Diagram({ image, screenReaderText }: DiagramProps) {
  return (
    <Center max={theme.space.measure}>
      {screenReaderText
        ? React.isValidElement(image) &&
          React.cloneElement(image as React.ReactElement<any, any>, { role: 'presentation' })
        : image}

      {screenReaderText && (
        <VisuallyHidden>
          <ol>
            {screenReaderText.map((text, i) => (
              <li key={`sr-${i}`}>{text}</li>
            ))}
          </ol>
        </VisuallyHidden>
      )}
    </Center>
  );
}
